import type { SessionRenewedResult, UserSessionHooks } from './login';
import { userProfileObtained, userSessionExpired, userSessionRenewed } from './login/loginSlice';
import { mapUserProfile } from './login/userProfile';
import { store } from './setup/store';
import { trace } from './setup/trace';
import { accessToken } from './tokenHandling/accessToken';
import { accessTokenStored, idTokenStored } from './tokenHandling/tokenSlice';

export const getUserSessionHooks = (): UserSessionHooks => ({
    onSessionExpired: () => {
        trace('oauthConfig: User session expired');
        accessToken.discardAccessToken();
        store.dispatch(accessTokenStored(null));
        store.dispatch(userSessionExpired());
    },
    onSessionRenewed: (result: SessionRenewedResult) => {
        trace('oauthConfig.onSessionRenewed', result);

        accessToken.saveAccessToken(result.accessToken);
        store.dispatch(accessTokenStored(result.accessToken));
        store.dispatch(idTokenStored(result.idToken));
        store.dispatch(userProfileObtained(mapUserProfile(result.profile)));

        store.dispatch(userSessionRenewed());
    },
});
